import * as ng from 'angular';

class ResumeApplicationModalController implements ng.IController {

    static $inject: string[] = [
        '$rootScope',
        '$scope'
    ];
    private close: any;
    constructor(
        private $rootScope: any, // ng.IRootScopeService,
        private $scope: any // ng.IScope,
    ) {
        $scope.resume = () => {
            $rootScope.startNotificationWorker();
            // $rootScope.notifyActiveConnection();
            this.close();
        };
    }
}

export const ResumeApplicationModalComponent: ng.IComponentOptions = {
    template: require('./resume-application-modal.html'),
    controller: ResumeApplicationModalController,
    bindings: {
        close: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/resume-application-modal/resume-application-modal.ts